import { withStyles } from '@material-ui/core/styles';
import { pxToRem } from "../../utils/formatFontSize";


const BrandedStyles = withStyles((theme) => ({
    '@global': {
        '.inputOnDark':{
            backgroundColor:'#FFFFFF'
        },
        '.bodyBold':{
            fontWeight:'bold'
        },
        '.simpleLink':{
            color:theme.palette.grey[800],
            textDecoration:'none'
        },
        '.smallTextBold':{
            fontSize:'12px',
            fontWeight:'bold'
        },
        '.smallerText':{
            fontSize:'12px'
        },
        '.smallText':{
            fontSize:'12px'
        },
        '.boldLabel':{
            '& .MuiFormLabel-root':{
                fontWeight:'bold',
                color:theme.palette.text.primary
            }
        },
        '.taxiBookingStepper':{
            '& .MuiStepConnector-horizontal':{
                top:20
            }
        },
        '.backButton':{
            color:theme.palette.error.main,
            borderColor:theme.palette.grey[500_32],
        },
        '.darkDialogue':{
            '& .MuiDialog-paper':{
                backgroundColor:theme.palette.grey[200],    
            },
            '& .MuiDialogTitle-root':{
                backgroundColor:theme.palette.grey[400],
                paddingTop:'12px',
                paddingBottom:'12px',
                textAlign:'center',
                fontSize:22,
            },
            '& .sectionBox':{
                marginBottom:'30px'
            },
            '& .sectionReady':{
                // borderColor:'#4BB543'
            },
            '& .sectionFocused':{
                borderColor:theme.palette.grey[900]
            },
            '& .sectionSummary':{
                display:'flex',
                '& .iconContainer':{
                    marginRight:'10px'
                },
                '& .iconContainer.iconReady':{
                    color:'#4BB543'
                }
            }
        },
        '.fareBlock':{
            lineHeight:'16px',
            display:'flex',
            fontSize:'12px',
            '& .feeAmountHolder':{
                textAlign:'right',
                flexGrow:'1'

            },
            '& .fareIconHolder':{
                paddingTop:'0px',
                
                '& .MuiSvgIcon-root':{
                    color:'#637381',
                    height:'16px'
                }
            }
        },
        '.savingsContainer':{
            marginBottom:'20px', 
            marginTop:'10px', 
            display:'flex', 
            flexDirection: 'row-reverse',
            '& .savingsLabel':{
                display:'flex',
                '& .textHolder':{
                    
                },
                '& .MuiSvgIcon-root':{
                    height:'16px'
                },
                '& .energySaving':{
                    color:'#015E0B'
                }
            },
        },
        '.dialogueSectionButonContainer':{
            marginBottom:'30px'
        },
        '.dialogueSectionToolsContainer':{
            display:'flex', 
            paddingTop:'10px',  
            justifyContent: 'flex-end',
            '& .MuiButton-root':{
                marginLeft:'10px'
            }
        },
        '.darkBox':{
            borderRadius:'3px', 
            boxShadow:'none',
            padding:'10px',
            backgroundColor:theme.palette.grey[200],
        },
        '.lightBox':{
            borderRadius:'3px', 
            boxShadow:'none',
            padding:'10px',
            backgroundColor:'#FFFFFF',
        },
        '.acYearBreakdown':{
            '& .yearSection':{
                marginTop:0,
                marginBottom:'10px',
                paddingTop:10,
                paddingBottom:10,
                paddingLeft:10,
                paddingRight:10,
                borderLeft:'4px solid',
                borderRight:'4px solid',
                '& .yearSectionTitleRow':{
                    display:'flex'
                },
                '& .typeChip':{
                    textTransform:'capitalize',
                },
                '&:hover': {
                    backgroundColor: theme.palette.action.hover // Add your desired hover background color here
                }
            },
            '& .sectionTitle':{
                fontWeight:'bold',
                textTransform:'capitalize',
                cursor:'pointer',
                fontSize:16,
            },
            '& .majorSection':{
                borderColor:theme.palette.flags.brandPurple,
                '& .sectionTitle':{
                    // fontSize:18,
                },
                '& .typeChip':{
                    backgroundColor:theme.palette.flags.brandPurple,
                    color:theme.palette.common.white,
                },
            },
            '& .minorSection':{
                borderColor:theme.palette.primary.main,
                '& .sectionTitle':{
                    // fontSize:14,
                },
                '& .typeChip':{
                    backgroundColor:theme.palette.primary.main,
                    color:theme.palette.common.white,
                },
            },
            '& .weeklySection':{
                borderColor:theme.palette.grey[500],
                '& .sectionTitle':{
                    // fontSize:12,
                }
            },
            '& .travelDateRes':{
                display:'flex',
                paddingRight:'10px',
                '& .dateIcon':{
                    color:theme.palette.grey[500],
                },
                '& .travelDateResInner':{
                    paddingRight:1, 
                    paddingTop:'2px'
                }
            },
            '& .travelDateRes.primaryTravelDate':{
                '& .dateIcon':{
                    color:theme.palette.flags.brandPurple,
                }
            }
        },
        '.smallMenu':{
            '& .MuiIconButton-root':{
                padding:4
            }
        },
        '.headerWarning':{
            marginTop:30,
            marginBottom:30
        },
        '.hiddenItinerary':{
            display:'none'
        },
        '.routeSelectionContainer':{
            '& .selectedRoute':{
                '& .routeTitle':{
                    fontWeight:'bold'  
                },
                '& .routeSubTitle':{
                    fontWeight:'bold'  
                },
                '& .selectedStop':{
                    backgroundColor:theme.palette.grey[500_32],
                }
            },
            '& .routeUnavailable':{
                '& .routeDetails':{
                    opacity:0.5
                }
            },
            '& .coachStopContainer':{
                display: 'flex',
                justifyContent: 'space-between',
                width:'500px',
                '& .stopDetailsContainer':{
                    minWidth:200
                },
                '& .stopToolsContainer':{
                    paddingLeft:10, 
                    flexShrink:0, 
                    minWidth:'160px'
                }
            },      
        },
        '& .coachRouteMap':{

            '& .leaflet-div-icon':{
                backgroundColor:'transparent',
                border:'none'
            },
            '& .marker-cluster':{
                
            },
            '& .pointMarker':{
                color: '#FFFFFF',
                backgroundColor: '#6C155A',
                width:24, 
                height:24,
                '& .MuiSvgIcon-root':{
                    fontSize:'1rem'
                }
            }
            
        },
        '.bookingButton':{
            [theme.breakpoints.up("sm")]: {
                minWidth:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            }
        },
        '.summaryButton':{
            [theme.breakpoints.up("sm")]: {
                minWidth:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            }
        },
        '.helperTex1t':{
            display:'none'
        },
        '.subTitle':{
            marginBottom:10
        },
        '.topHelperText':{
            fontWeight: 400,
            lineHeight: 1.4,
            fontSize: pxToRem(13)
        },
        '.metaText':{
            color:theme.palette.primary.main,
        },
        '.dateField': {
            [theme.breakpoints.up("sm")]: {
                minWidth:400
            },
            [theme.breakpoints.down("sm")]: {
                width:'100%'
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: theme.palette.primary.main,
                },
            }
        },
        '.toggleButtonContainer':{
            paddingTop:15,
            paddingBottom:15
        },
        '.standAloneButton':{
            marginTop:40,
            marginBottom:40,
        },
        '.smallIconContainer':{
            paddingLeft:'4px',
            paddingRight:'4px',
            paddingTop:'1px',
            width:22, 
            height:22,
            color:'#FFFFFF',
            borderRadius:12, 
            '& svg':{
                borderRadius:7, 
                width:14, 
                height:14,
                fontSize:10
            }
        },
        '.fareDetailsTable':{
            '& .headerCell':{
                textAlign:'right',
                paddingTop:0,
                paddingBottom:0,
                backgroundColor:'unset',
                boxShadow:'unset',
                paddingRight:'1px',
                paddingLeft:'1px',
                '& .MuiTypography-root':{
                    fontWeight:600,
                    fontSize:'12px'
                },
            },
            '& .rowCell':{
                textAlign:'right',
                paddingTop:0,
                paddingBottom:0,
                paddingRight:'1px',
                paddingLeft:'1px',
                '& .MuiTypography-root':{
                    fontSize:'12px'
                },
            },
            '& .rowCell.boldCell':{
                '& .MuiTypography-root':{
                    fontWeight:600
                },
            },
            '& .rowCellKey':{
                textAlign:'left',
                paddingTop:0,
                paddingBottom:0,
                paddingRight:'1px',
                paddingLeft:'1px',
                minWidth:'160px',
                '& .MuiTypography-root':{
                    fontSize:'12px'
                },
            },
            '& .totalsRow':{
                '& .MuiTableCell-root':{
                    borderTop:'1px solid #CCC'
                },
            },
            '& .profitRow':{
                '& .MuiTableCell-root':{
                    fontWeight:600
                },
                '& .rowCellKey':{
                    '& .MuiTypography-root':{
                        fontWeight:600
                    },
                },
                '& .rowCell':{
                    '& .MuiTypography-root':{
                        fontWeight:600
                    },
                }
            }
        },
        '.superMegaBigButton':{
          width:230,
          height:230,
          color:theme.palette.primary.main,
            cursor:"pointer",
            borderRadius:10,
            textAlign:"center",
            border: `1px solid ${theme.palette.grey[500_32]}`,

            '&:hover': {
                backgroundColor: theme.palette.action.hover,
                borderColor:theme.palette.primary.main,
                boxShadow: 'none',
                transition: "backgroundColor 2s, borderColor 1s",
            },
          '& svg':{
              fontSize:150
          }
        },
        '.lowButtonContainer':{
            marginTop:40,
            marginBottom:40,
        },
        '.childSelect':{
            cursor:'pointer',
        },
        '.childSelectSelected':{
            cursor:'pointer',
            '& .studentAvatar':{
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.success.main
            }
        },
        '.slideTitle':{
            marginBottom:20
        },
        '.legDetails':{
            '& :nth-of-type(1)':{
                marginTop:20,
            },
            marginBottom:20,
            marginLeft:20
        },
        '.summaryTreeTitle':{
            textTransform:'capitalize'
        },
        '.summaryLocationDot':{
            backgroundColor:theme.palette.primary.main,
        },
        '.summaryModeDot':{
            backgroundColor:theme.palette.success.main,
            border: 1,
            borderColor: theme.palette.secondary.main,
        },
        '.smallDetailsTable':{
            [theme.breakpoints.up("sm")]: {
                '& table': {
                    width: 'max-content'
                },
            },
            '& td:nth-of-type(1)':{
                borderRight:'1px solid rgba(145, 158, 171, 0.24)'
            },
            '& td':{
                paddingTop:4,
                paddingBottom:4
            }
        },
        '.taxiDetailDialogue':{
            '& .MuiDialogTitle-root':{
                backgroundColor:'#CCCCCC',
                paddingTop:'12px',
                paddingBottom:'12px',
                textAlign:'center',
                fontSize:22
            }
        },
        '.flightDataFlightNo':{
            color:theme.palette.primary.main,
        },
        '.flightDataIcons':{
            marginRight:pxToRem(20),

            lineHeight:1.5,
            color:theme.palette.primary.main,
        },
        '.formContainer-oldRemove':{
            minHeight:500
        },
        '.formContainer':{
            overflow:'visible !important'
        },
        '.MuiPaper-root':{
            '& .MuiCard-root':{
                '& .boxyAutoComplete':{
                    zIndex:40000,
                    '& .MuiAutocomplete-popper':{
                        zIndex: 40000
                    },
                    '& .MuiAutocomplete-listbox':{
                        zIndex: 40000
                    }
                }        
            }
        },
        '.boxyAutoComplete':{
            zIndex:40000,
            '& .MuiAutocomplete-popper':{
                zIndex: '3000 !important'
            },
            '& .MuiAutocomplete-listbox':{
                zIndex: '20000 !important'
            }
        },
        '.companySelector':{
            minWidth:400
        },
        '.umDetails':{
          flexGrow:1,
          borderLeft:'1px solid',
          borderColor:theme.palette.primary.main,
          paddingLeft:20,
          '& .boxStack':{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              '& .studentInputRow':{
                  paddingLeft:5
              }
          }
        },
        '.primaryAirport':{

        },
        '.secondaryAirport':{
            color:theme.palette.primary.light
        },
        '.bookingCancelled':{
            opacity:0.3
        },
        '.activeMerge':{
            backgroundColor:theme.palette.grey[400]
        },
        '.iconLive':{
            color:theme.palette.success.main
        },
        '.iconPending': {
            color: theme.palette.warning.main
        },
        '.topFilterButton':{

        },
        '.activeFilter':{

        },
        '.searchChip':{
            color:theme.palette.primary.main,
            '& span':{
                paddingTop:5,
                lineHeight:2,
                fontSize:12

            }
        },
        '.okMobile':{
            color: theme.palette.primary.main
        },
        '.badMobile':{
            color: theme.palette.flags.red
        },
        '.unapproved':{
            color: theme.palette.primary.main
        },
        '.partApproved':{
            color: theme.palette.flags.yellow
        },
        '.fullyApproved':{
            color: theme.palette.flags.green
        },
        '.iconButton':{
            cursor:'pointer'
        },
        '.stripyRow':{
            '&:nth-child(even) > td': {
                backgroundColor: theme.palette.grey[200]

            }
        },
        '.clickLink':{
            cursor:'pointer',
            textDecoration:'none'
        },

        '.iconBooked':{
            color: theme.palette.flags.yellow
        },
        '.topStatusBox':{
            [theme.breakpoints.down("xl")]: {
                paddingRight:20
            },
        },
        '.rowButtons':{
            paddingLeft:0,
            paddingRight:0,
            paddingTop:0,
            paddingBottom:0,
            minWidth:0,
            fontWeight:'normal'
        },
        '.bookingBox':{            
            height:30,
            '& .innerBookingBox':{
                display:'inline-block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
            '& .innerBookingButton':{
                display:'inline-block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
        },
        '.bookingBox.toolsBox':{
            display:'flex',
            justifyContent:'flex-end',
        },
        '.stepperAvatarTravelMode':{
            cursor:'pointer',
            width:30,
            height:30,
            backgroundColor:theme.palette.warning.light,
            '& > .MuiSvgIcon-fontSizeMedium':{
                fontSize:16,
                color:theme.palette.primary.contrastText
            },
            '& > .iconHelp':{
                color:theme.palette.primary.contrastText
            },
        },
        '.accountSelector':{
            '& .selectorLabel':{
                color: theme.palette.primary.main
            },
            '& .releaseButton':{
              marginLeft:10
            }
        },
        '.bigWideTable':{
            '& .MuiTable-root':{
                borderBottom:'0px solid #FF0000',
            },
            [theme.breakpoints.up("md")]: {
                minWidth: 500, 
                maxWidth:'100%',
                // border:'1px solid #FF0000'
            },
            [theme.breakpoints.down("lg")]: {
                minWidth: 500, 
                maxWidth: 1080,
                // border:'1px solid #FF00FF'

            },
            [theme.breakpoints.down("md")]: {
                minWidth: 500, 
                maxWidth:740,
                // border:'1px solid #0000FF'
            },
            [theme.breakpoints.down("sm")]: {
                minWidth: 200, 
                maxWidth:320,
                // border:'1px solid #00FF00'
            },
            '& .MuiTableRow-head':{
                '& .MuiTableCell-root':{
                    padding:'4px',
                    boxShadow:'inset 0px 0 0 #fff'
                }
            },
            '& .MuiTableCell-root':{
                padding:'4px'
            }
        },
        '.MuiTablePagination-root':{
            marginTop:20
        },
        '.mapOuterContainer':{
            position:'relative', 
            width:'100%', 
            height:'100%',
            '& .mapInnerContainer':{
                position:'absolute', 
                top:0, 
                left:0, 
                width:'100%', 
                height:'100%',
                '& .mapBox':{
                    width:'100%',
                    height:'100%'
                }
            },
            [theme.breakpoints.down("md")]:{
                marginBottom:'-88px'
            },
            '& .mapInfoBox':{
                position:'absolute', 
                zIndex:900, 
                minWidth:300,
                backgroundColor:'rgba(21, 90, 108, 0.8)',
                padding:'20px 3px 20px 3px',
                color:'#FFFFFF',
                [theme.breakpoints.down("md")]: {
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    borderTopLeftRadius:0,
                    borderTopRightRadius:0
                },
                '& .statusTitle':{
                    textAlign:'center', 
                    fontWeight:700, 
                    fontSize:18
                },
                '& .labelCell':{
                    color:'#FFFFFF', 
                    fontWeight:'bold', 
                    textAlign:'right', 
                    fontSize:14, 
                    borderRight:'1px solid #FFFFFF', 
                    padding:'5px 10px 5px 20px', 
                    lineHeight:1.2
                },
                '& .dataCell':{
                    color:'#FFFFFF', 
                    fontSize:14, 
                    padding:'5px 20px 5px 10px', 
                    lineHeight:1.2
                }
            },
            '& .dataBox':{
                
                [theme.breakpoints.up("md")]: {
                    right:30, 
                    top:30,
                    '& .speedBoxInner':{
                        display:'none'
                    }
                },
                [theme.breakpoints.down("md")]: {
                    right:0,
                    height:'100%',
                    width:200
                },
                [theme.breakpoints.down("sm")]: {
                    bottom:0,
                    width:'100%',
                    height:'auto'
                },
                
            },
            '& .speedBoxInner':{
                display: 'flex',
                alignItems: 'center',
                fontSize:18,
                flexWrap: 'wrap',
                justifyContent: 'center',
                '& .speedIcon':{
                    height:30, 
                    marginRight:10
                }
            },
            '& .speedBox':{
                [theme.breakpoints.up("md")]: {
                    right:30, 
                    bottom:30,
                    textAlign:'center'
                },
                [theme.breakpoints.down("md")]: {
                    display:'none'
                }
            }
        },
        '.footerNavContainer':{
            [theme.breakpoints.up("xl")]: {
                position:'fixed',
                bottom:0,
                left: 0,
                right: 0,
                margin: 'auto',
                width: 'fit-content',
                
                paddingLeft:'100px',
                paddingRight:'100px',
            },
            '& .footerNav': {
                display: 'flex',
                justifyContent: 'center',
                [theme.breakpoints.up("sm")]: {
                    paddingTop:'20px',
                    paddingBottom:'20px',
                },
                '& .MuiTypography-root': {
                    fontSize: '12px',
                    marginRight: '10px',
                },
                '& .MuiLink-root': {
                    color:theme.palette.grey[800],
                    textDecoration: 'none',
                    marginLeft: '10px',
                    marginRight: '10px',
                    position: 'relative',
                    '&::before': {
                        content: '"|"',
                        marginLeft: '5px',
                        marginRight: '5px',
                        position: 'absolute',
                        left: '-15px'
                    },
                }
            }
        },
        '.widgetTabs':{
            overflow:'visible !important',
            '& .MuiTabs-scroller':{
                overflow:'visible !important',
            },
            '& .buttonTab':{
                fontSize:'16px',
                fontWeight:'bold'
            },
            '& .MuiTabs-indicator':{
                backgroundColor:theme.palette.grey[300],
                height:'4px',
                marginBottom:'-2px'
            }
        },
        '.bigWidget':{
            '& .MuiCardHeader-root':{
                
            },
            '& .bigWidgetHeader':{
                backgroundColor:theme.palette.grey[300],
                '& .MuiCardHeader-title':{
                    fontSize:'18px',
                    fontWeight:600
                },
                '& .MuiButtonBase-root':{
                    color:'#000000'
                }
            },
            '& .bigWidgetHeader.isOpen':{
                backgroundColor:theme.palette.primary.main,
                color:'#FFFFFF',
                '& .menuOpener':{
                    color:'#FFFFFF'
                },
                '& .MuiButtonBase-root':{
                    color:'#FFFFFF'
                }
            },
            '& .innerBigWidget':{
                padding:20
            },
            marginBottom:20
        },
        '.travelDatesAccordion':{
            '& .MuiAccordionSummary-content':{
                marginTop:'5px',
                marginBottom:'5px'
            }
        }
    },

}))(() => null);

export default BrandedStyles;